import React, { useContext, useState, useEffect } from 'react';
import SocketContext from './socketContext';
import SOCKET_CONFIG from './socketServiceConfig';
import io from 'socket.io-client';

export function useSocket() {
	return useContext(SocketContext);
}

export default function SocketService({ children }) {
	const [socket, setSocket] = useState();

	useEffect(() => {
		// const newSocket = io(SOCKET_CONFIG.server, {
		// 	transports: ['websocket'],
		// });
		// setSocket(newSocket);
		// return () => newSocket.close();
	}, []);

	return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
}
